import { render, staticRenderFns } from "./HomeAvaliacoes.vue?vue&type=template&id=b32bc3e0&scoped=true&"
import script from "./HomeAvaliacoes.vue?vue&type=script&lang=js&"
export * from "./HomeAvaliacoes.vue?vue&type=script&lang=js&"
import style0 from "./HomeAvaliacoes.vue?vue&type=style&index=0&id=b32bc3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32bc3e0",
  null
  
)

export default component.exports